export interface FileSubmission {
    id: number;
    fileName: string;
    createdDate: string;
    deliveredDate: string | null;
    pbm: string;
    status: 'Created' | 'Delivered' | 'Failed';
    transactionCount: number;
}

interface FileSubmissionResponse {
    submissions: FileSubmission[];
    totalCount: number;
}

import apiClient from '../utils/apiClient';

export const getFileSubmissions = async (period: 'daily' | 'weekly'): Promise<FileSubmissionResponse> => {
    return apiClient.get<FileSubmissionResponse>(`/api/files/submissions?period=${period}`);
};

export const getFileDetails = async (fileId: number): Promise<FileSubmission> => {
    return apiClient.get<FileSubmission>(`/api/files/${fileId}`);
};

export const retryFileDelivery = async (fileId: number): Promise<void> => {
    await apiClient.post(`/api/files/${fileId}/retry`);
};
